"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function generateNewTag() {
    return Math.random().toString();
}
exports.generateNewTag = generateNewTag;
//# sourceMappingURL=generateNewTag.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/posterControllerSupportingClasses/generateNewTag.js
// module id = 62
// module chunks = 0